import { FilterCriteriaItem, PageParam } from './appDomain';
import { MeasurementUnitEnum } from './measurementDomain';

export enum ParcelCategoryEnum {
  FC = 'FC',
  LC = 'LC',
  SC = 'SC',
  T = 'T',
  CP = 'CP',
}
export const ParcelCategoryDisplay: {
  [key in ParcelCategoryEnum]: string;
} = {
  [ParcelCategoryEnum.FC]: 'Flat Carton',
  [ParcelCategoryEnum.LC]: 'Large Carton',
  [ParcelCategoryEnum.SC]: 'Standard Carton',
  [ParcelCategoryEnum.T]: 'Tube',
  [ParcelCategoryEnum.CP]: 'Carrier Parcel',
};

export const ParcelCategoryOptions = [
  {
    value: ParcelCategoryEnum.FC,
    name: ParcelCategoryDisplay[ParcelCategoryEnum.FC],
  },
  {
    value: ParcelCategoryEnum.LC,
    name: ParcelCategoryDisplay[ParcelCategoryEnum.LC],
  },
  {
    value: ParcelCategoryEnum.SC,
    name: ParcelCategoryDisplay[ParcelCategoryEnum.SC],
  },
  {
    value: ParcelCategoryEnum.T,
    name: ParcelCategoryDisplay[ParcelCategoryEnum.T],
  },
  {
    value: ParcelCategoryEnum.CP,
    name: ParcelCategoryDisplay[ParcelCategoryEnum.CP],
  },
];

export interface Parcel {
  /** Metric twins, sent alongside so switching units needs no refetch. */
  widthMm?: number;
  lengthMm?: number;
  heightMm?: number;
  weightKg?: number;

  id: number;
  revxId: string;
  name: string;
  widthIn: number;
  weightLb: number;
  heightIn: number;
  lengthIn: number;
  price: number;
  markupPct: number;
  category: ParcelCategoryEnum;
  itemsPerParcel?: number;
  active: boolean;
  orgId: number;
  isBase: boolean;
  baseRefId?: number;
}

export type PartialParcel = Partial<Parcel>;

export interface ListParcelParam {
  page: PageParam;
  query?: ParcelFilterObj;
}

export interface ParcelFilterObj {
  id?: FilterCriteriaItem;
  revxId?: FilterCriteriaItem;
  active?: boolean;
  name?: FilterCriteriaItem;
  category?: FilterCriteriaItem;
  lengthIn?: FilterCriteriaItem;
  widthIn?: FilterCriteriaItem;
  heightIn?: FilterCriteriaItem;
  weightLb?: FilterCriteriaItem;
  price?: FilterCriteriaItem;
  markupPct?: FilterCriteriaItem;
  /**
   * The unit the numeric criteria above were typed in.
   *
   * Travels with the filter rather than being read at the moment of the request: the list is
   * re-fetched on every page change and sort, long after the panel that typed `widthIn: 210` has
   * closed, and a 210 matched against inches finds nothing.
   */
  enteredUnit?: MeasurementUnitEnum;
}
